import {
  AnimationEvent,
  animate,
  style,
  transition,
  trigger,
} from '@angular/animations'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { Router } from '@angular/router'
import { MegaMenuItem } from 'primeng/api'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'
import { BehaviorSubject, Observable } from 'rxjs'
import { Applicationpreference, Practice } from '../../../api/models'
import {
    AppPreferencesService,
  AppSettingService,
  RecentlyVisitedService,
  RolesService,
  UserPracticesService,
} from '../../../api/services'
import { AuthService } from '../../../api/services/auth.service'
import { AppComponent } from '../../../app.component'
import { AppMainComponent } from '../../../app.main.component'
import { CareFinitySession } from '../../services/CareFinitySession'
import { AuthGuard } from '../../services/auth-guard'
import { UserprofileComponent } from '../user/userprofile/userprofile.component'
import { SelectPracticeComponent } from '../select-practice/select-practice.component'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scaleY(0.8)' }),
                animate(
                    '.12s cubic-bezier(0, 0, 0.2, 1)',
                    style({ opacity: 1, transform: '*' }),
                ),
            ]),
            transition(':leave', [animate('.1s linear', style({ opacity: 0 }))]),
        ]),
    ],
})
export class AppTopBarComponent implements OnInit {
    practices: Array<Practice>
    practiceControl: UntypedFormControl
    practiceName: string = ''
    ismuliple: boolean = false

    version: string = '5.0.0';
    public currentUserprivelleges: BehaviorSubject<Practice>

    ref: DynamicDialogRef | undefined

    constructor(
        private recentlyVisitedService: RecentlyVisitedService,
        private router: Router,
        private authService: AuthService,
        private userPracticesService: UserPracticesService,
        public appMain: AppMainComponent,
        public app: AppComponent,
        private appSetting: AppSettingService,
        private _guard: AuthGuard,
        public dialogService: DialogService
    ) { }

    ngOnInit() {

        this.version = environment.version;
        this.practiceControl = new UntypedFormControl('')

        this.loadPractices()
    }

    get loggedInUserName(): string {
        return CareFinitySession.user?.name
    }

    activeItem: number

    model: MegaMenuItem[] = []

    @ViewChild('searchInput') searchInputViewChild: ElementRef

    onSearchAnimationEnd(event: AnimationEvent) {
        switch (event.toState) {
            case 'visible':
                this.searchInputViewChild.nativeElement.focus()
                break
        }
    }

    loadPractices() {
        this.practices = JSON.parse(localStorage.getItem('user_practices'))
        if (this.practices.length > 0 && this.practices.length == 1) {
            this.navigateTopbarToDashboard(this.practices[0].practiceid)

            this.ismuliple = false
            this.practiceName = this.practices[0].name

            return
        } else {
            this.ismuliple = true
        }
        this.practiceControl.patchValue(this.practices[0].practiceid)
        this.practiceControl.patchValue(localStorage.getItem('PracticeId'))
    }

    onPracticeSelected(): void {
        this.navigateTopbarToDashboard(this.practiceControl.value)
    }

    navigateTopbarToDashboard(practiceId: string) {
        // console.log("id is ", practiceId)
        this.userPracticesService
            .userPracticesFetchSettings({ practiceId: practiceId })
            .subscribe((data) => {
                this.appSetting.appSettingGetPracticeSettings$Response().subscribe({
                    next: (settings) => {
                        CareFinitySession.selectPractice(data[0], settings.body)


                      


                    }
                })
            })
    }

    logout() {
        CareFinitySession.logout(this.authService)
        this.router.navigate(['/login'])
    }

    LoadPrfilepage() {
        this.ref = this.dialogService.open(UserprofileComponent, {
            //data: {
            //    id: '12345'
            //},
            header: 'User Profile',
            width: '40%',
            height: '38.5%',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: false,
        })
    }
    LoadHomepage() {


        this.router.navigateByUrl(localStorage.getItem('homeurl'));

    }


    LoadUserPreference() {

        this.router.navigate(["/settings/user-pref"]);
    }
}
